'use client'

import { useEffect } from 'react'
import { trackPageView } from '@/utilities/gtag'

/**
 * P0-2 (doc 046): mount a single explicit GA4 `page_view` per page so the
 * `page_location` reflects the post-redirect URL (e.g. after apex → www
 * → /de) instead of whatever `document.location` was at script-load time.
 * The matching `gtag('config', …, { send_page_view: false })` call lives
 * in `src/app/(app)/[locale]/layout.tsx` — keep them in sync.
 *
 * P2-7 (doc 046): skip the explicit `page_view` (and any downstream GA4
 * events) for known bot user-agents so Singapore / China / Slovakia
 * crawler traffic doesn't pollute the metrics. The list is intentionally
 * short and conservative — matches `Googlebot`, `bingbot`, `AhrefsBot`,
 * `SemrushBot`, etc. GA4's built-in bot filter handles a lot of this
 * server-side already, but a client-side guard belt-and-braces the data
 * quality fix.
 */
const BOT_UA_PATTERN =
  /bot|crawl|spider|slurp|bingpreview|facebookexternalhit|WhatsApp\//i
// whatsapp, telegram, discord intentionally NOT filtered — real humans use
// their in-app browsers; GA4's built-in bot filter handles crawler traffic
// server-side. Only filter confirmed bot UA substrings here. P0-2b (doc 047).

export function PageViewTracker() {
  useEffect(() => {
    if (typeof navigator !== 'undefined' && BOT_UA_PATTERN.test(navigator.userAgent)) {
      return
    }
    trackPageView()
  }, [])
  return null
}
